import {Component, OnInit} from '@angular/core';
import {AuthManagerService} from "src/app/auth/auth-manager.service";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {LoginData} from "src/app/auth/auth.model";
import {Router} from "@angular/router";
import {usernameValidator} from "../../utils/validation/validators";

@Component({
  selector: 'app-super-admin-login',
  templateUrl: './super-admin-login.component.html',
  styleUrls: ['./super-admin-login.component.scss']
})
export class SuperAdminLoginComponent implements OnInit {

  form: FormGroup;
  showError: boolean = false;

  constructor(
    private auth: AuthManagerService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      username: new FormControl([], [Validators.required, usernameValidator]),
      password: new FormControl([], [Validators.required])
    });
  }

  submit() {
    if (this.form.valid) {
      let data: LoginData = {
        username: this.form.get("username").value,
        password: this.form.get("password").value
      };
      this.auth.login(data, true).subscribe(response => {
        if (response.success) {
          this.form.reset();
          this.router.navigate(['/sa/home']);
        } else {
          this.showError = true;
        }
      });
    } else {
      this.showError = true;
    }
  }
}
